import AboutUs from "../AboutUs/AboutUs";
import OurMission from "../OurMission/OurMission";
import WeDo from "../WeDo/WeDo";
import OurActivity from "../OurActivity/OurActivity";
// import WeExpertise from "../WeExpertise/WeExpertise";
import MachineDetails from "../MachineDetails/MachineDetails";

import OurProductsRange from "../OurProductsRange/OurProductsRange";

const Home = () => {
  return (
    <div>
      <AboutUs />
      <OurMission />
      <WeDo />
      <OurActivity />
      {/* <WeExpertise /> */}
      <OurProductsRange />
      <MachineDetails />
    </div>
  );
};

export default Home;
